import { Checkbox } from 'components/Checkbox/Checkbox'
import React from 'react'
import { colors } from 'settings/colors'

const rowWrapperStyle = {
  'alignItems': 'center',
  'border': `1px solid ${colors.grey200}`,
  'display': 'flex',
  'transition': '0.15s ease all',
  '&:hover': {
    background: colors.subtleBackground,
  },
}

export type TEntity = {
  id: number | string
  name: string
  checked: boolean
}

type EntityRowProps = {
  entity: TEntity
  setSelected: (selected: boolean, entityId: TEntity['id']) => void
  style?: React.CSSProperties
}

export const EntityRow = (props: EntityRowProps) => {
  const { entity, setSelected, style } = props

  return (
    <div
      css={{
        ...rowWrapperStyle,
        cursor: 'pointer',
        borderTop: undefined,
        ...style,
      }}
    >
      <Checkbox
        checked={entity.checked}
        onChange={() => {
          setSelected(!entity.checked, entity.id)
        }}
        css={{ padding: '4px 2px 4px 10px' }}
      />

      <div
        css={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: '1 1 auto',
          padding: '4px 10px',
        }}
        onClick={() => {
          setSelected(!entity.checked, entity.id)
        }}
      >{`${entity.name} (${entity.id})`}</div>
    </div>
  )
}
